; (function (jQuery) {

	"use strict";
	function detailsBlock($block) {
		var fn = {
			init: function () {
				$block.find('select').on('change', fn.changeDetails);
			},
			changeDetails: function (e) {
				let organisation = jQuery(this).val();
				let $block = jQuery(this).parents('.organisation-contact-details');
				$block.find('.organisation-contact-details__details').hide();
				$block.find('.organisation-contact-details__details[data-organisation="' + organisation + '"]').show();
			},
		}

		jQuery(fn.init);
	}

	jQuery('.organisation-contact-details').each(function(){
		new detailsBlock(jQuery(this));
	});

})(jQuery);
